import React, {Component} from 'react';
import moment from 'moment';
import 'moment/locale/tr';
import {Col, Row} from 'reactstrap';
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import DefaultModal from "../invoice/DefaultModal";
import Alert from "react-s-alert";
import axios from 'axios';
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";

class SendMultiplePayTrModal extends Component {

	constructor(props){
		super(props);
		this.state={
			error:{},
			loading:false ,
			documentList:[],
			index:0,
			realIndex:0,
			path: this.props.path
		};
		this.onCancel 		= this.onCancel.bind(this);
		this.sendNextDocument = this.sendNextDocument.bind(this);
	}

	componentDidMount() {
		let self = this;
		let params = {
			url: '/'+this.state.path+'/getDocuments',
			method: 'post'
		};
		self.setState({btnDisabled:true,loading:true});
		request(params)
		.then(function (response) {
			let documentList = response.data;
			self.setState({
				btnDisabled: false,
				documentList,
				loading: false
			});
		}).catch(function (error) {
			self.setState({btnDisabled:false,loading:false});
			showAxiosError(error);
		});
	}

	sendNextDocument(index){
		let self= this;
		this._source = axios.CancelToken.source();
		let documentList = deepCopyObject(self.state.documentList);
		if(index < documentList.length){
			let document = documentList[index];
			document.selectedXslt = self.state.selectedXslt;
			document.selectedPrefix = self.state.selectedPrefix;
			document.proifleId=self.props.profileId;
			let params = {
				url:  '/'+this.state.path+'/sendNextDocument',
				method: 'post',
				cancelToken: self._source.token,
				data: document.recordId
			};

			document.frontEndStatus = "loadinging";
			document.statusText = "Gönderim Başlatıldı.";
			documentList[index]=document;
			self.setState({btnDisabled:true,documentList});
			request(params)
			.then(function (response) {
				let document = response.data;
				document.frontEndStatus = "success";
				document.statusText = "Gönderim Başarılı";
				documentList[index]= document;
				self.setState({documentList,index: (index+1)});
				if(index + 1 < documentList.length){
					if((index+1) % 5 === 0){
						documentList.splice(0,4);
						self.setState({realIndex:(self.state.realIndex+4)});
						self.sendNextDocument((index+1)-4);
					}else{
						self.sendNextDocument(index+1);
					}
				}else{
					self.setState({btnDisabled:false,index: index+1});
					self.props.toggleModal(true,true);
					return;
				}
			}).catch(function (error) {
				if (axios.isCancel(error)) {

				}else{
					document.frontEndStatus = "error";
					document.statusText = "Gönderim Başarısız";
					documentList[index]= document;
					self.setState({documentList,btnDisabled:false});
					showAxiosError(error);
				}
				return;
			});
		}else{
			Alert.warning('Tüm dokümanlar gönderildi.', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
			return;
		}
	}

	onCancel(){
		if(this._source)
			this._source.cancel();

		if(this.state.index > 0){
			this.props.toggleModal(false,true);
		}else{
			this.props.toggleModal(false,false);
		}
	}

	getStatusRender(frontEndStatus) {
		let className =(frontEndStatus === "loadinging" ? "spinner fa-spin" : (frontEndStatus==="success" ? "check" :(frontEndStatus==="error" ? "close":"pause")));
		let color= (frontEndStatus === "loadinging" ? "dark" : (frontEndStatus==="success" ? "green" :(frontEndStatus==="error" ? "red":"dark")));
		return (<i className={"fas fa-" + className} style={{color:color,paddingRight:"4px"}}></i>);
	}

	render(){
		console.log("this.state.documentList",this.state.documentList);
		return(
			<DefaultModal
				isOpen={this.props.modal}
				disabled={this.state.btnDisabled || (this.state.documentList && this.state.documentList.length ===0)}
				title={this.props.title}
				size="xl"
				modalBodyStyle={{padding: "0", minHeight: "500px"}}
				confirmBtnText="Toplu Gönder"
				cancelBtnText="İptal"
				onConfirm={(e)=>this.sendNextDocument(this.state.index)}
				onCancel={this.onCancel}>
				<Row>
					<Col sm="12" style={{marginBottom: "15px"}}>
						<div>
							<div className="card-body">
								<Row>
									<Col sm="12" style={{paddingRight: '5px', maxHeight:'500px', overflow:"auto"}}>
										<table className="" style={{textAlign: 'center', paddingBottom: "5px"}}>
											<thead>
												<tr style={{backgroundColor: '#ebedf0'}}>
													<th>#</th>
													{this.state.path === 'progresspayment' &&
													<th>Başlangıç Tarihi</th>
													}
													{this.state.path === 'progresspayment' &&
													<th>Bitiş Tarihi</th>
													}
													{this.state.path !== 'progresspayment' &&
													<th>Tarih/Saat</th>
													}
													<th>Unvan</th>
													<th>VKN/TCKN</th>
													{this.state.path !== 'progresspayment' &&
													<th>Alım Yeri</th>
													}
													{this.state.path !== 'progresspayment' &&
													<th>Fiyat</th>
													}
													{this.state.path === 'progresspayment' &&
													<th>Hakediş Tutarı</th>
													}
													{this.state.path !== 'progresspayment' &&
													<th>Doküman No</th>
													}
													<th>Durum</th>
												</tr>
											</thead>
											<tbody>
											{ this.state.documentList && this.state.documentList.map((document, index) =>
												<tr key={index+"_"+document.recordId} style={{backgroundColor:(document.documentId ? "lightgreen" :"")}}>
													<td style={{margin:"0px"}}>{this.state.realIndex + (index+1)}</td>
													{this.state.path === 'progresspayment' &&
													<td style={{margin: "0px"}}>{moment((document.startDate)).format("DD-MM-YYYY")}</td>
													}
													{this.state.path === 'progresspayment' &&
													<td style={{margin: "0px"}}>{moment((document.finishDate)).format("DD-MM-YYYY")}</td>
													}
													{this.state.path !== 'progresspayment' &&
													<td style={{margin: "0px"}}>{moment((document.updatedAt)).format("DD-MM-YYYY")}</td>
													}
													<td style={{margin:"0px"}}>{<TextOverFlowTooltip text={this.state.path==='progresspayment' ? document.distributor.customerName : document.customer.customerName} maxLength={16}/>}</td>
													<td style={{margin:"0px"}}>{this.state.path==='progresspayment' ? document.distributor.vknTckn : document.customer.vknTckn}</td>
													{this.state.path !== 'progresspayment' &&<td style={{margin:"0px"}}>{<TextOverFlowTooltip text={document.host} maxLength={16}/>}</td> }
													{this.state.path !== 'progresspayment' &&
													<td style={{margin: "0px"}}>{document.totalPrice}</td>
													}
													{this.state.path === 'progresspayment' &&
													<td style={{margin: "0px"}}>{document.totalAmount}</td>
													}

													{this.state.path !== 'progresspayment' &&
													<td style={{margin: "0px"}}>{document.documentId}</td>
													}
													<td style={{margin:"0px"}}>{this.getStatusRender(document.frontEndStatus)}{(document.statusText || "Gönderim Bekliyor...")}</td>
												</tr>
											)}
											{!this.state.loading && (this.state.documentList &&this.state.documentList.length === 0) &&
												<tr>
													<td colSpan="8">Kayıt bulunamadı</td>
												</tr>
											}
											{this.state.loading &&
												<tr>
													<td colSpan="8">Doküman işleniyor...</td>
												</tr>
											}
											</tbody>
										</table>
									</Col>
									<Col sm="12">
										<p style={{float:"right"}}>Toplam Doküman Adeti: {this.state.documentList ? this.state.documentList.length : 0}</p>
									</Col>
								</Row>
							</div>
						</div>
					</Col>
				</Row>
			</DefaultModal>
		);
	}
}

export default SendMultiplePayTrModal;

